import React from 'react';

import { Button, Container, Grid, makeStyles, Typography, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    btn: {
      marginTop: '41px',
      width: '40%',
    },
    container: {
      maxWidth: '500px',
      padding: '26px',
    },
    field: {
      marginTop: '8px',
      width: '100%',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '4px',
    },
    message: {
      color: '#999999',
      fontSize: '14px !important',
      lineHeight: '22px',
      marginBottom: '0px',
    },
  };
});
export default ({ onCancel, onConfirm, name, code }) => {
  const classes = useStyles();

  const handleConfirm = () => {
    if (!onConfirm || typeof onConfirm !== 'function') return;
    onConfirm({ code, name });
  };

  return (
    <Container disableGutters className={classes.container}>
      <Grid container className="text-left-">
        <Grid item xs={12} className="text-left">
          <Typography className={`${classes.formTitle}`}>Delete Discount</Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" className={`body-copy ${classes.message}`}>
            Are you sure you want to delete this discount?
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField placeholder="Enter discount name" type="text" variant="standard" disabled className={classes.field} value={name} label="Name" />

          <div style={{ marginTop: '8px' }}>
            <TextField placeholder="Enter coupon code" type="text" variant="standard" className={classes.field} value={code} label="Coupon Code" />
          </div>
        </Grid>

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4} style={{ paddingRight: '6px' }}>
              <Button variant="link" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={onCancel} className={classes.btn}>
                Cancel
              </Button>
            </Grid>
            <Grid item xs={8} style={{ paddingLeft: '6px' }}>
              <Button variant="contained" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={handleConfirm} className={classes.btn}>
                Delete Discount
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
